import React from "react";

const SVG = ({
  style ={},//"enable-background:new 0 0 49.827 49.827;",
  fill = "#010002",
  width = "100%",
  className = "",
  viewBox = "0 0 49.827 49.827"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M44.939,41.327c0,4.687-3.813,8.5-8.5,8.5H13.388c-4.687,0-8.5-3.813-8.5-8.5
		c0-1.933,1.567-3.5,3.5-3.5s3.5,1.567,3.5,3.5c0,0.827,0.673,1.5,1.5,1.5h23.051c0.827,0,1.5-0.673,1.5-1.5
		c0-1.933,1.567-3.5,3.5-3.5S44.939,39.394,44.939,41.327z M22.439,34.302c0.657,0.656,1.547,1.025,2.475,1.025
		s1.818-0.369,2.475-1.025l10.333-10.334c1.367-1.367,1.367-3.583,0-4.95c-1.367-1.366-3.584-1.367-4.949,0l-4.358,4.358V3.5
		c0-1.933-1.567-3.5-3.5-3.5s-3.5,1.567-3.5,3.5v19.877l-4.359-4.359c-1.367-1.366-3.583-1.366-4.95,0
		c-1.367,1.367-1.367,3.583,0,4.95L22.439,34.302z"
    />
  </svg>
);

export default SVG;
